import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configuración Firebase con fallbacks para producción
const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ||
    "AIzaSyAhzzm79XG9FPq1XDzkICHQCxS6zLMZLMo",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "vettconsult.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "vettconsult",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    "vettconsult.firebasestorage.app",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "193016570271",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ||
    "1:193016570271:web:4c791ddd0dd9a6c6ae9daa",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-J2BYXYZ18F",
};

// Validar configuración antes de inicializar
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "undefined") {
  console.error(
    "Firebase API Key is missing or invalid:",
    firebaseConfig.apiKey
  );
  throw new Error(
    "Firebase configuration is invalid. Please check your environment variables."
  );
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Initialize analytics conditionally to avoid cookie issues
let analytics: any = null;
try {
  // Only initialize analytics in production and if cookies are allowed
  if (typeof window !== "undefined" && import.meta.env.PROD) {
    // Check if cookies are enabled to avoid the "m" cookie rejection issue
    const cookiesEnabled = navigator.cookieEnabled;

    if (cookiesEnabled) {
      isSupported()
        .then((supported) => {
          if (supported) {
            analytics = getAnalytics(app);
          }
        })
        .catch((error) => {
          console.warn("[Firebase] ⚠️ Analytics initialization failed:", error);
        });
    }
  }
} catch (error) {
  console.warn("[Firebase] ⚠️ Analytics setup failed:", error);
}

export { analytics };

export const googleProvider = new GoogleAuthProvider();

googleProvider.addScope("profile");
googleProvider.addScope("email");

googleProvider.setCustomParameters({
  prompt: "select_account",
});

export default app;
